import 'css-chunksrc/feature/modifier-command/ModifierCommandPaletteChip.module.scss';export default {
  "root": "ModifierCommandPaletteChip_root",
  "minus": "ModifierCommandPaletteChip_minus",
  "plus": "ModifierCommandPaletteChip_plus"
};